import React, { useState } from "react";
import { Modal, Button, Input } from "semantic-ui-react";
import { producaov2 as api, local } from "../../../../services/apis";
import { InputContainer } from "./styled";
import InputMask from "react-input-mask";
import swal from "sweetalert";
import { Select } from 'semantic-ui-react';

export default function ModalCreateParceiro({ open, handleClose,getData }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [instagram, setInstagram] = useState('');
  const [linkedin, setLinkedin] = useState('');
  const [tipo, setTipo] = useState(1);
  const [modeloParceria, setModeloParceria] = useState("");


  const handleSubmit = async () => {
    if (name === '' || email === '' || telefone === '') {
      swal("Preencha todos os campos!", '', "error");
      return;
    }

    const payload = {
      nome:name,
      email,
      telefone,
      instagram,
      linkedin,
      tipo,
      modelo_parceria:modeloParceria,
    }


    console.log("::: payload::: => ", payload)
    await api.post('/admin/parcerias/create', payload).then(res => {
      swal("Parceria Criada", '', "success");
      getData();
      closeModal();
    }).catch(err => {
      console.log(err)
    })
  }


  const options = [
    { key: '1', value: 1, text: 'Afiliado' },
    { key: '2', value: 2, text: 'Embaixador' },
    { key: '3', value: 3, text: 'Instrutor' },
    { key: '4', value: 4, text: 'Instituição' },
    { key: '5', value: 5, text: 'Eventos' },
    { key: '6', value: 6, text: 'Conteúdos' },
    { key: '7', value: 7, text: 'Movimento Estudantil' },
  ]

  const closeModal = () => {
    setName('')
    setEmail('')
    setTelefone("")
    setInstagram("")
    setLinkedin("")
    setTipo(1);
    setModeloParceria("")
    handleClose(false)
  }


  return (
    <>
      <Modal
        size={"small"}
        open={open}
        onClose={() => closeModal()}
      >
        <Modal.Header>Registrar novo Parceiro</Modal.Header>
        <Modal.Content>
          <Modal.Description></Modal.Description>

          <InputContainer>
            <label>Name</label>
            <Input placeholder='Nome Parceiro' value={name} onChange={e => setName(e.target.value)} />
          </InputContainer>
          <InputContainer>
            <label>Email</label>
            <Input placeholder='Email Parceiro' value={email} onChange={e => setEmail(e.target.value)} />
          </InputContainer>
          <InputContainer>
            <label>Celular</label>
            <Input placeholder='Celular' value={telefone} onChange={e => setTelefone(e.target.value)} />
          </InputContainer>
          <InputContainer>
            <label>Instagram</label>
            <Input placeholder='https://www.instagram.com/grupovoitto/' value={instagram} onChange={e => setInstagram(e.target.value)} />
          </InputContainer>
          <InputContainer>
            <label>Linkedin</label>
            <Input placeholder='https://www.linkedin.com/in/henricop/' value={linkedin} onChange={e => setLinkedin(e.target.value)} />
          </InputContainer>
          <InputContainer>
            <label>Tipo de Parceria</label>
            <Select placeholder='Escolha o tipo' defaultValue={tipo} value={tipo} options={options}
                onChange={(e, data) => setTipo(data.value)} />
          </InputContainer>
          <InputContainer>
            <label>Modelo Parceria</label>
            <Input placeholder='Palestra' value={modeloParceria} onChange={e => setModeloParceria(e.target.value)} />
          </InputContainer>

        </Modal.Content>
        <Modal.Actions>
          <Button type="button" positive onClick={() => handleSubmit()} >
            Cadastrar
          </Button>
          <Button onClick={() => closeModal()}>
            Cancelar
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  )
}
